import { render, staticRenderFns } from "./PublicResults.vue?vue&type=template&id=2598ec6c&scoped=true&"
import script from "./PublicResults.vue?vue&type=script&lang=js&"
export * from "./PublicResults.vue?vue&type=script&lang=js&"
import style0 from "./PublicResults.vue?vue&type=style&index=0&id=2598ec6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2598ec6c",
  null
  
)

export default component.exports